import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Loader2 } from "lucide-react";

export default function AdminRoute({ children }) {
  const { authenticated, checking } = useAdminAuth();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-white/30 animate-spin mx-auto mb-4" />
          <p className="text-xs text-white/40 tracking-widest uppercase">
            Verifying access...
          </p>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
